import { useMemo, useEffect } from 'react';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import { useDispatch, useSelector } from 'react-redux';
import { sagaActions } from '../../../../store/sagaActions';
import Navbar from '../../../../Components/Nav';
import ChangePageTitle from '../../../../Components/ChangePageTitle';
import { yearColumnDefs } from './YearColumns';
import { defaultColDefinition } from '../../../../utils/data/DefaultColumn';
import { useNavigate } from 'react-router-dom';

export default function FilterYear() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const studentDetails = useSelector((state) => state.student);
  const { data: studentData, error } = studentDetails;

  useEffect(() => {
    if (studentData.length === 0 && error === '') {
      dispatch({ type: sagaActions.FETCH_STUDENT_DATA });
    }
  }, [dispatch, studentData.length, error]);

  const rowData = useMemo(() => {
    if (studentData.length === 0) return [];

    const genderObject = studentData.reduce((prevData, currentStudent) => {
      const { year: { year_id, year_name }, status: { status_name } } = currentStudent;

      if (!prevData.hasOwnProperty(year_id)) {
        prevData[year_id] = { yearId: year_id, year: year_name, total: 0 };
      }

      const currentStatusKey = status_name.toString().replace(' ', '').toLowerCase();
      if (!prevData[year_id].hasOwnProperty(currentStatusKey)) {
        prevData[year_id][currentStatusKey] = 1;
      } else {
        prevData[year_id][currentStatusKey] += 1;
      }

      prevData[year_id]['total'] += 1;

      return prevData;
    }, {});

    return Object.values(genderObject);
  }, [studentData]);

  const handleClick = (event) => {
    navigate(`/students?year=${event.data.yearId}`);
  };

  return (
    <>
      <ChangePageTitle pageTitle='Alumni Connect 2026 | Count - Years' />
      <Navbar breadCrumb={['Analytics', 'Student-Year']}>
        <div className='ag-theme-alpine table-without-search'>
          <AgGridReact
            rowData={rowData}
            columnDefs={yearColumnDefs}
            defaultColDef={defaultColDefinition}
            suppressExcelExport={true}
            onRowClicked={handleClick}
          />
        </div>
      </Navbar>
    </>
  );
}
